module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-boards', {
    staticClass: "md-primary hello-board",
    attrs: {
      "md-controls": true
    }
  }, [_c('md-board', {
    staticClass: "hello-board slide1",
    attrs: {
      "id": "slide1"
    }
  }, [_c('md-layout', {
    staticClass: "title",
    attrs: {
      "md-column": ""
    }
  }, [_c('span', {
    staticClass: "md-headline"
  }, [_vm._v("CERTIFICAÇÃO DAS INSTALAÇÕES E EQUIPAMENTOS DO BLH")]), _vm._v(" "), _c('span', {
    staticClass: "md-title"
  }, [_vm._v("BEM VINDO")])]), _vm._v(" "), _c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../assets/blh_logo.jpg")
    }
  })], 1), _vm._v(" "), _c('md-board', {
    staticClass: "hello-board slide2"
  }, [_c('md-layout', {
    attrs: {
      "md-column": ""
    }
  }, [_c('span', {
    staticClass: "md-title"
  }, [_vm._v("\n        Para acessar a certificação, entre com os dados de usuario e senha.\n      ")]), _vm._v(" "), _c('span', {
    staticClass: "md-caption"
  }, [_vm._v("\n        Estes dados são fornecido após o processo de credenciamento.\n      ")]), _vm._v(" "), _c('span', {
    staticClass: "md-caption"
  }, [_vm._v("\n        Qualquer dúvida entre em contato através do site "), _c('a', {
    attrs: {
      "href": "https://rblh.fiocruz.br"
    }
  }, [_vm._v("Rede Brasileira de Bancos de Leite Humano")])]), _vm._v(" "), _c('md-button', {
    staticClass: "login md-raised md-accent",
    on: {
      "click": _vm.login
    }
  }, [_vm._v("Acessar o Processo de Certificação")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-49609218","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hello.vue
// module id = 831
// module chunks = 1